const outsourcedCosts = {
    year1: {
      baseServiceFees: {
        nocServices: { cost: 4500000, quantity: 1, total: 4500000 },
        toolAndPlatformAccess: { cost: 800000, quantity: 1, total: 800000 },
        standardSLACoverage: { cost: 700000, quantity: 1, total: 700000 },
        total: 6000000
      },
      perSiteCharges: {
        emeaSites: { cost: 24000, quantity: 45, total: 1080000 },
        usaSites: { cost: 22000, quantity: 50, total: 1100000 },
        chinaSites: { cost: 28000, quantity: 35, total: 980000 },
        total: 3160000
      },
      premiumServices: {
        enhancedSLACoverage: { cost: 500000, quantity: 1, total: 500000 },
        specializedTechSupport: { cost: 400000, quantity: 1, total: 400000 },
        customReporting: { cost: 200000, quantity: 1, total: 200000 },
        total: 1100000
      },
      retainedOrganization: {
        internalStaff: {
          vendorManager: { cost: 160000, quantity: 1, total: 160000 },
          technicalLeads: { cost: 160000, quantity: 3, total: 480000 },
          regionalCoordinators: { cost: 120000, quantity: 3, total: 360000 },
          benefitsAndOverhead: { cost: 300000, quantity: 1, total: 300000 },
          total: 1300000
        },
        internalToolsAndSystems: {
          monitoringAndOversight: { cost: 200000, quantity: 1, total: 200000 },
          integrationMaintenance: { cost: 150000, quantity: 1, total: 150000 },
          total: 350000
        }
      },
      totalOperationalCosts: 11910000,
      oneTimeAndOperationalCosts: 12810000,
      yearTotal: 12810000
    },
    year2: {
      baseServiceFees: {
        nocServices: { cost: 4500000, quantity: 1, total: 4500000 },
        toolAndPlatformAccess: { cost: 800000, quantity: 1, total: 800000 },
        standardSLACoverage: { cost: 700000, quantity: 1, total: 700000 },
        total: 6000000
      },
      perSiteCharges: {
        emeaSites: { cost: 24000, quantity: 45, total: 1080000 },
        usaSites: { cost: 22000, quantity: 50, total: 1100000 },
        chinaSites: { cost: 28000, quantity: 35, total: 980000 },
        total: 3160000
      },
      premiumServices: {
        enhancedSLACoverage: { cost: 500000, quantity: 1, total: 500000 },
        specializedTechSupport: { cost: 400000, quantity: 1, total: 400000 },
        customReporting: { cost: 200000, quantity: 1, total: 200000 },
        total: 1100000
      },
      retainedOrganization: {
        internalStaff: {
          vendorManager: { cost: 160000, quantity: 1, total: 160000 },
          technicalLeads: { cost: 160000, quantity: 3, total: 480000 },
          regionalCoordinators: { cost: 120000, quantity: 3, total: 360000 },
          benefitsAndOverhead: { cost: 300000, quantity: 1, total: 300000 },
          total: 1300000
        },
        internalToolsAndSystems: {
          monitoringAndOversight: { cost: 200000, quantity: 1, total: 200000 },
          integrationMaintenance: { cost: 150000, quantity: 1, total: 150000 },
          total: 350000
        }
      },
      totalOperationalCosts: 11910000,
      yearTotal: 12267300
    },
    year3: {
      baseServiceFees: {
        nocServices: { cost: 4500000, quantity: 1, total: 4500000 },
        toolAndPlatformAccess: { cost: 800000, quantity: 1, total: 800000 },
        standardSLACoverage: { cost: 700000, quantity: 1, total: 700000 },
        total: 6000000
      },
      perSiteCharges: {
        emeaSites: { cost: 24000, quantity: 45, total: 1080000 },
        usaSites: { cost: 22000, quantity: 50, total: 1100000 },
        chinaSites: { cost: 28000, quantity: 35, total: 980000 },
        total: 3160000
      },
      premiumServices: {
        enhancedSLACoverage: { cost: 500000, quantity: 1, total: 500000 },
        specializedTechSupport: { cost: 400000, quantity: 1, total: 400000 },
        customReporting: { cost: 200000, quantity: 1, total: 200000 },
        total: 1100000
      },
      retainedOrganization: {
        internalStaff: {
          vendorManager: { cost: 160000, quantity: 1, total: 160000 },
          technicalLeads: { cost: 160000, quantity: 3, total: 480000 },
          regionalCoordinators: { cost: 120000, quantity: 3, total: 360000 },
          benefitsAndOverhead: { cost: 300000, quantity: 1, total: 300000 },
          total: 1300000
        },
        internalToolsAndSystems: {
          monitoringAndOversight: { cost: 200000, quantity: 1, total: 200000 },
          integrationMaintenance: { cost: 150000, quantity: 1, total: 150000 },
          total: 350000
        }
      },
      totalOperationalCosts: 11910000,
      yearTotal: 12624600
    },
    threeYearTotal: 37701900
  };
  
  export default outsourcedCosts;